export const SEARCH_FAILED = 'NIKManagement/search-failed';
export const SEARCH_LOADING = 'NIKManagement/search-loading';
export const SEARCH_SUCCESS = 'NIKManagement/search-success';
